export function initInScope($scope) {
    $scope.find('.js-hero__links').on('click', function () {
        $(this).addClass('is-active');
    });
}